<template>
  <div>
    <!-- Start Page Content -->
    <div class="row">
      <div class="col-md-6">
        <div class="card bg-primary p-20">
          <div class="media widget-ten">
            <div class="media-left meida media-middle">
              <span>
                <i class="ti-bag f-s-40"></i>
              </span>
            </div>
            <div class="media-body media-text-right">
              <h2 class="color-white">{{systemProducts.length}}</h2>
              <p class="m-b-0">PRODUCTS</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card bg-pink p-20">
          <div class="media widget-ten">
            <div class="media-left meida media-middle">
              <span>
                <i class="ti-truck f-s-40"></i>
              </span>
            </div>
            <div class="media-body media-text-right">
              <h2 class="color-white">{{systemTrucks.length}}</h2>
              <p class="m-b-0">TRUCKS</p>
            </div>
          </div>
        </div>
      </div>
    
    </div>

    <!-- /# row -->

    <!-- End PAge Content -->
  </div>
</template>
<script>
import authservice from "../configurations/authentications/auth";
import router from "../router/index";
import { mapActions, mapGetters } from "vuex";
export default {
  created() {
    let Auth = new authservice();

    const expireTime = Auth.loggedIn();
    
    if (expireTime === null) {
      router.push("/login");
    }
    this.loadProduct();
    this.loadTrucks();
  },
  computed: {
    ...mapGetters(["systemProducts", "systemTrucks"])
  },
  methods: {
    ...mapActions(["loadProduct", "loadTrucks"])
  }
};
</script>


// WEBPACK FOOTER //
// src/dashboard/index.vue